export const blockIconsHomeShieldWithHeartNew = (
	<span className='material-symbols-outlined'>shield_with_heart</span>
);
